import { useCallback } from "react";
import { usePublishPropertyListing } from "./usePropertyListings";

// Shared publish/copy-link handlers for the listings tables. Wraps the publish
// mutation and a clipboard "copy public link" action so both the Sale and
// Rental pages behave identically. `onChanged` is called after a successful
// toggle so the page can refetch.
export function useListingPublishControls({ onChanged } = {}) {
  const { mutate, pendingId } = usePublishPropertyListing();

  const onTogglePublish = useCallback(
    async (item, next) => {
      try {
        await mutate(item.id, next);
        onChanged?.();
      } catch (err) {
        const msg =
          err?.response?.data?.errors?.join(", ") ||
          "Could not update the listing's visibility. Please try again.";
        // eslint-disable-next-line no-alert
        window.alert(msg);
      }
    },
    [mutate, onChanged],
  );

  const onCopyLink = useCallback((item) => {
    if (!item.public_path) return;
    const url = `${window.location.origin}${item.public_path}`;
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url);
    } else {
      // eslint-disable-next-line no-alert
      window.prompt("Copy this public link:", url);
    }
  }, []);

  return { onTogglePublish, onCopyLink, publishPendingId: pendingId };
}
